import React from 'react';
import { FaUserGraduate, FaAward, FaBookOpen } from 'react-icons/fa';
import './Students.css';
import { professorData } from '../data';

export default function Students() {
  const { phdsAwarded, metrics } = professorData;

  return (
    <section id="students" className="students section">
      <div className="container">
        <div className="section-header">
          <span className="section-label">Academic Mentorship</span>
          <h2 className="section-title">Research Guidance</h2>
          <div className="section-rule"></div>
        </div>

        <div className="students__summary">
          <div className="students__summary-card students__summary-card--primary">
            <div className="students__summary-icon">
              <FaUserGraduate size={28} />
            </div>
            <div className="students__summary-val">{metrics.phdsAwarded}</div>
            <div className="students__summary-label">Ph.Ds Awarded</div>
          </div>
          <div className="students__summary-card students__summary-card--secondary">
            <div className="students__summary-icon">
              <FaBookOpen size={28} />
            </div>
            <div className="students__summary-val">{metrics.phdsOngoing}</div>
            <div className="students__summary-label">Ph.Ds Ongoing</div>
          </div>
          <div className="students__summary-card students__summary-card--gold">
            <div className="students__summary-icon">
              <FaAward size={28} />
            </div>
            <div className="students__summary-val">{metrics.phdsAwarded + metrics.phdsOngoing}</div>
            <div className="students__summary-label">Total Scholars</div>
          </div>
        </div>

        <div className="students__grid">
          {phdsAwarded.map((phd, i) => (
            <div key={i} className="student-card">
              <div className="student-card__header">
                <div className="student-card__avatar">
                  <FaUserGraduate />
                </div>
                <div className="student-card__meta">
                  <span className="student-card__year">{phd.year}</span>
                  {phd.fellowship && (
                    <span className="student-card__fellowship">{phd.fellowship}</span>
                  )}
                </div>
              </div>
              <div className="student-card__body">
                <h3 className="student-card__name">{phd.name}</h3>
                <p className="student-card__thesis">
                  <strong>Thesis:</strong> {phd.title}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
